<template>
    <ul class="list-group list-group-flush">
        <li class="list-group-item" v-for="choice in choices">
            <input type="checkbox" :id="choice.id" :value="choice.id" v-model="answers" @change="$emit('handleChoiceChange', answers)">
            <label :for="choice.id">
                {{choice.text}}
            </label>
        </li>
    </ul>
</template>
<script>
    export default {
        props: [
            'choices', 'answersSaved'
        ],
        data(){
            return{
                answers: [],
                init: false
            }
        },
        watch:{
            answersSaved : function(){
                if(this.init === false){
                    this.initForm();
                    this.init = true;
                }
            }
        },
        methods: {
            initForm: function(){
                let i = 0;
                let al = this.answersSaved.length;
                for(i; i <= al; i++){
                    Vue.set(this.answers, i, this.answersSaved[i]);
                }
            }
        }
    }
</script>
